export default {
  inheritClassName(props: AnyFixMe, defaultClassName: AnyFixMe) {
    return (
      (defaultClassName ? defaultClassName : '') +
      (props.className ? ` ${props.className}` : '')
    );
  },
};
